export default __webpack_public_path__ + "static/media/stock_clinic_emr-min.0b5f6b93.jpg";